import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const BloggerImageUpload = async (payload) => {
  try {
    const response = await APIs.post('/cloudinary_file_upload', payload);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const postBlogger = async (payload) => {
  try {
    const response = await APIs.post('/create_blog', payload);

    if (response?.data?.message === 'success') {
      toast('Posted successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editABlogger = async (payload) => {
  try {
    const response = await APIs.patch('/edit_blog', payload);

    if (response?.data?.message === 'success') {
      toast('Posted successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getBlogger = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_blogs/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getMyBlogger = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_my_blogs/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllBlogger = async (payload) => {
  try {
    const response = await APIs.get(`/get_blogs/${payload}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleBlogger = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_post/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getBloggerComment = async (payload) => {
  try {
    const response = await APIs.get(`/single_post_comment/${payload}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const createComment = async (payload) => {
  try {
    const response = await APIs.post(`/comment/${payload.id}`, payload);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllBlogCount = async () => {
  try {
    const response = await APIs.get(`/get_all_blog_count`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForBlogByTitle = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_blog_by_title/${payload?.title}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      // toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const BloggersServices = {
  BloggerImageUpload,
  postBlogger,
  getBlogger,
  getMyBlogger,
  getSingleBlogger,
  getAllBlogger,
  editABlogger,
  getBloggerComment,
  createComment,
  getAllBlogCount,
  SearchForBlogByTitle,
};

export default BloggersServices;
